import type { AmenityDto } from '@/shared/api/modules/contracts';
import type { Amenity } from '../model/types';

export const transformAmenityDtoToAmenity = (dto: AmenityDto): Amenity => {
  const { id, isSelected, name } = dto;

  return {
    id,
    name,
    isSelected,
  };
};
